/**
 * Material Icons → KTSVG Icon Mapping
 * Backend'den dönen Material Icon name'lerini projedeki KTSVG path'lerine map eder
 */

export const ICON_MAPPING: Record<string, string> = {
  // Feature List Icons
  'check_circle': '/media/icons/duotone/Navigation/Check.svg',
  'star': '/media/icons/duotone/General/Star.svg',
  'done': '/media/icons/duotone/Navigation/Check.svg',
  'arrow_right': '/media/icons/duotone/Navigation/Arrow-right.svg',
  'verified': '/media/icons/duotone/General/Shield-check.svg',
  'favorite': '/media/icons/duotone/General/Heart.svg',
  'thumb_up': '/media/icons/duotone/General/Like.svg',
  'bolt': '/media/icons/duotone/General/Thunder.svg',
  'local_shipping': '/media/icons/duotone/Shopping/Box3.svg',
  'security': '/media/icons/duotone/General/Shield-protected.svg',
  'workspace_premium': '/media/icons/duotone/General/Star.svg',
  'verified_user': '/media/icons/duotone/Communication/Shield-user.svg',

  // Icon Text Block Icons
  'info': '/media/icons/duotone/Code/Info-circle.svg',
  'warning': '/media/icons/duotone/Code/Warning-2.svg',
  'error': '/media/icons/duotone/Code/Error-circle.svg',
  'campaign': '/media/icons/duotone/Communication/Spam.svg',
  'local_offer': '/media/icons/duotone/Shopping/Sale1.svg',
  'card_giftcard': '/media/icons/duotone/Shopping/Gift.svg',
  'schedule': '/media/icons/duotone/General/Clock.svg',
  'location_on': '/media/icons/duotone/Map/Marker1.svg',
  'phone': '/media/icons/duotone/Devices/Phone.svg',
  'email': '/media/icons/duotone/Communication/Mail.svg',
  'support_agent': '/media/icons/duotone/Communication/Group-chat.svg',
};

/**
 * Material Icon name'ini KTSVG path'e çevirir
 * Eğer mapping yoksa default icon döner
 */
export const getIconPath = (iconName: string): string => {
  return ICON_MAPPING[iconName] || '/media/icons/duotone/Navigation/Check.svg';
};
